/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const STORE_LOCATOR_LIBRARY: any = ['places'];
export const STORE_LIST_RADIUS = 40;
export const GOOGLE_MAP_REGION = 'ca';

export const GOOGLE_MAP_ZOOM = {
	INIT: 5,
	ZOOM: 13,
};

export const DEFAULT_LOCATION = {
	// Toronto
	lat: 24.4814272,
	lng: -104.3809292,
};

export const STORE_LOCATOR_STATE_KEY = 'storeLocator';
